// @flow

//This funciton shoudl return immediately on modern browser
//on old browser, it will dynamically download polyfills
export function requirePolyfill() {
    //Promise is always included in the main js
    //because if it is not, then the following import() syntax
    //which return Promise will NOT work in IE
    if (!window.Promise) {
        window.Promise = require("core-js/fn/promise");
    }

    //following use import() syntax to dynamic load polyfill parallel
    //if they do not present

    let customPromise = Promise.resolve();
    if (!window.CustomEvent || typeof CustomEvent !== "function") {
        customPromise = import("custom-event").then(CustomEvent => {
            window.CustomEvent = CustomEvent;
        });
    }

    let fetchPromise = Promise.resolve();
    if (!window.fetch) {
        fetchPromise = import("whatwg-fetch");
    }

    let assignPromise = Promise.resolve();
    if (!Object.assign) {
        assignPromise = import("core-js/fn/object/assign").then(assign => {
            Object.assign = assign;
        });
    }

    //use promise.all to load and wait for all of them
    return Promise.all([customPromise, fetchPromise, assignPromise]);
}
